import { render, staticRenderFns } from "./NestedLists.vue?vue&type=template&id=a4804a9a&"
import script from "./NestedLists.vue?vue&type=script&lang=js&"
export * from "./NestedLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports